import { SOCIAL_AUTH_CALLBACK_PATH } from './social-auth.constants';

/** Yandex and VK both return to this path, sometimes with a trailing slash. */
export function isSocialAuthCallbackPath(pathname: string): boolean {
  const normalized: string = pathname.replace(/\/+$/, '') || '/';
  return normalized === SOCIAL_AUTH_CALLBACK_PATH;
}
